"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.dateFormatter = dateFormatter;exports.dateSimpleFormatter = dateSimpleFormatter;exports.simpleFormatter = simpleFormatter;exports.datesFormatter = datesFormatter;exports.sexFormatter = sexFormatter;exports.userSexFormatter = userSexFormatter;exports.statusFormatter = statusFormatter;exports.czStatusFormatter = czStatusFormatter;exports.upgradeFormatter = upgradeFormatter;exports.isEndFormatter = isEndFormatter;exports.typeFormatter = typeFormatter;exports.reviewFormatter = reviewFormatter;exports.terminalFormatter = terminalFormatter;exports.upgradeStatusFormatter = upgradeStatusFormatter;exports.xunfeiStatusFormatter = xunfeiStatusFormatter;exports.isForceFormatter = isForceFormatter;exports.auditStatusFormatter = auditStatusFormatter;exports.isEnabledFormatter = isEnabledFormatter;exports.isEnabled2Formatter = isEnabled2Formatter;exports.downloadTypeFormatter = downloadTypeFormatter;exports.terminalTypeFormatter = terminalTypeFormatter;exports.enabledFormatter = enabledFormatter;exports.firmwareTypeFormatter = firmwareTypeFormatter;exports.isAuditingFormatter = isAuditingFormatter;exports.sysTypeFormatter = sysTypeFormatter;exports.menuTypeFormatter = menuTypeFormatter;exports.tigueIndexFormatter = tigueIndexFormatter;exports.acheIndexFormatter = acheIndexFormatter;exports.nwbsssFormatter = nwbsssFormatter;exports.sorenessFormatter = sorenessFormatter;exports.acheDegreeFormatter = acheDegreeFormatter;exports.bloodoxygenPulseRateFormatter = bloodoxygenPulseRateFormatter;exports.supportSecretKeyFormatter = supportSecretKeyFormatter;exports.businessTypeFormatter = businessTypeFormatter;exports.independentUserSysFormatter = independentUserSysFormatter;exports.shelfStatusFormatter = shelfStatusFormatter;exports.recommendStatusFormatter = recommendStatusFormatter;exports.recommendNewReasonFormatter = recommendNewReasonFormatter;exports.hardwareModuleTypeFormatter = hardwareModuleTypeFormatter;exports.otaIsForceFormatter = otaIsForceFormatter;exports.otaRangeformatter = otaRangeformatter;exports.otaAuditStatusFormatter = otaAuditStatusFormatter;exports.otaSituationStatusFormatter = otaSituationStatusFormatter;exports.msgFeedbackNoticeType = msgFeedbackNoticeType;exports.msgFeedbackEmails = msgFeedbackEmails;exports.deviceTypeFormatter = deviceTypeFormatter;exports.appUpgradeLogStatus = appUpgradeLogStatus;exports.staticManageFileTypeFormatter = staticManageFileTypeFormatter;exports.staticManageUploadStatusFormatter = staticManageUploadStatusFormatter;



var _index = require("@/utils/index"); /**
                                        *  格式化函数
                                        *  主要用于table表格列formatter属性格式化
                                        */

function dateFormatter(row, column) {
  var val = row[column.property];
  if (!val) {
    return '';
  }
  return (0, _index.parseTime)(val, '{y}-{m}-{d} {h}:{i}:{s}');
}
function dateSimpleFormatter(row, column) {
  var val = row[column.property];
  if (!val) {
    return '';
  }
  // var now = new Date(val)
  return (0, _index.parseTime)(val, '{y}-{m}-{d}');
}
function simpleFormatter(val) {
  if (!val) {
    return '';
  }
  // var now = new Date(val)
  return (0, _index.parseTime)(val, '{y}-{m}-{d}');
}
/**
   * 日期格式化2 (非列表展示使用)
   */
function datesFormatter(val) {
  if (!val) {
    return '';
  }
  return (0, _index.parseTime)(val, '{y}-{m}-{d} {h}:{i}:{s}');
}

/**
   * 后台-性别格式化
   */
function sexFormatter(row, column) {
  var val = row[column.property];
  if (val === 1) {
    return '男';
  } else if (val === 2) {
    return '女';
  } else {
    return val;
  }
}

/**
   * 用户-性别格式化
   */
function userSexFormatter(row, column) {
  var val = row[column.property];
  if (val == 1) {
    return '男';
  } else if (val == 0) {
    return '女';
  } else {
    return val;
  }
}

/**
   * 禁用状态格式化
   */
function statusFormatter(row, column) {
  var val = row[column.property];
  if (val === 1 || val === '1') {
    return '启用';
  } else if (val === 0 || val === '2') {
    return '禁用';
  }
  return val;
}
/**
   * 操作状态格式化
   */
function czStatusFormatter(row, column) {
  var val = row[column.property];
  if (val === 1) {
    return '异常';
  } else if (val === 0) {
    return '正常';
  }
  return val;
}
/**
   * 升级状态格式化
   * 在设备管理中使用
   */
function upgradeFormatter(row, column) {
  var val = row[column.property];
  if (val === 1) {
    return '允许';
  } else if (val === 0) {
    return '禁用';
  }
  return val;
}

/**
   * 是否为末级格式化
   */
function isEndFormatter(row, column) {
  var val = row[column.property];
  if (val === '0') {
    return '否';
  } else if (val === '1') {
    return '是';
  } else {
    return val;
  }
}

/**
   * 类型格式化
   */
function typeFormatter(row, column) {
  var val = row[column.property];
  if (val === '1') {
    return '固定';
  } else if (val === '2') {
    return '组合';
  }
}

/**
   * 审核状态格式化
   */
function reviewFormatter(row, column) {
  var val = row[column.property];
  console.log('val:' + val);
  if (val === 1) {
    return '已审核';
  } else {
    return '未审核';
  }
}

/**
   * 终端类型格式化
   */
function terminalFormatter(row, column) {
  var val = row[column.property];
  if (val === '1') {
    return 'pad';
  } else if (val === '2') {
    return 'phone';
  }
}
/**
   * 升级状态格式化
   */
function upgradeStatusFormatter(row, column) {
  var val = row[column.property];
  switch (val) {
    case 0:
      return '开始升级';
    case 1:
      return '升级成功';
    case 2:
      return '升级失败';}

}
/**
   * 讯飞状态格式化
   */
function xunfeiStatusFormatter(row, column) {
  var val = row[column.property];
  switch (val) {
    case 0:
      return '升级成功';
    case 1:
      return '开始升级';
    case 2:
      return '手动降级';
    case 3:
      return '升级失败';}

}
/**
   * 是否强制升级
   */
function isForceFormatter(row, column) {
  var val = row[column.property];
  if (val === 0) {
    return '否';
  } else if (val === 1) {
    return '是';
  } else {
    return val;
  }
}

/**
   * 审核格式化
   */
function auditStatusFormatter(row, column) {
  var val = row[column.property];
  if (val === 0) {
    return '未封存';
  } else if (val === 1) {
    return '封存通过';
  } else if (val === 2) {
    return '封存未通过';
  } else {
    return val;
  }
}

function isEnabledFormatter(row, column) {
  var val = row[column.property];
  if (val === '0') {
    return '禁用';
  } else if (val === '1') {
    return '启用';
  } else {
    return val;
  }
}
function isEnabled2Formatter(row, column) {
  var val = row[column.property];
  if (val === '0') {
    return '启';
  } else if (val === '1') {
    return '禁';
  } else {
    return val;
  }
}

/**
   * 下载类型格式化
   */
function downloadTypeFormatter(row, column) {
  var val = row[column.property];
  if (val === 1) {
    return '监控中心发布';
  } else if (val === 0) {
    return 'URL下载';
  } else {
    return val;
  }
}

/**
   * 终端类型格式化
   * 中心版本-兼容版本 中使用
   */
function terminalTypeFormatter(row, column) {
  var val = row[column.property];
  if (val === 1) {
    return 'IOS';
  } else if (val === 2) {
    return '安卓';
  } else if (val === 3) {
    return 'ipad';
  } else if (val === 4) {
    return '安卓pad';
  }
}
/**
   * 是否启用格式化
   */
function enabledFormatter(row, column) {
  var val = row[column.property];
  if (val === '0' || val === false) {
    return '禁用';
  } else if (val === '1' || val === true) {
    return '启用';
  } else {
    return val;
  }
}
/**
   * 固件类型格式化
   */
function firmwareTypeFormatter(row, column) {
  var val = row[column.property];
  if (val === 0) {
    return 'wifi模块';
  } else if (val === 1) {
    return '主板模块';
  } else {
    return val;
  }
}
/**
   * 是否审核中格式化
   */
function isAuditingFormatter(row, column) {
  var val = row[column.property];
  if (val === 0) {
    return '正常';
  } else if (val === 1) {
    return '审核中';
  } else {
    return val;
  }
}
/**
   * 系统类型格式化
   */
function sysTypeFormatter(row, column) {
  var val = row[column.property];
  if (val === 1) {
    return 'ios';
  } else if (val === 2) {
    return 'android';
  } else if (val === 3) {
    return 'ipad';
  }
}
/**
   * 菜单类型格式化
   */
function menuTypeFormatter(row, column) {
  var val = row[column.property];
  if (val === 1) {
    return '菜单';
  } else if (val === 2) {
    return '按钮';
  }
  return val;
}
/**
   * 疲劳程度格式化
   */
function tigueIndexFormatter(row, column) {
  var val = row[column.property];
  if (val === 0) {
    return '无';
  } else if (val === 1) {
    return '轻度';
  } else if (val === 2) {
    return '中度';
  } else if (val === 3) {
    return '重度';
  }
  return val;
}
/**
   * 酸痛程度格式化
   */
function acheIndexFormatter(row, column) {
  var val = row[column.property];
  if (val === 0) {
    return '正常';
  } else if (val === 1) {
    return '轻度';
  } else if (val === 2) {
    return '中度';
  } else if (val === 3) {
    return '重度';
  } else if (val === 4) {
    return '严重';
  }
  return val;
}
/**
   * 部位酸痛值格式化
   */
function nwbsssFormatter(row, column) {
  var val = row[column.property];
  if (val === 0) {
    return '轻度';
  } else if (val === 1) {
    return '中度';
  } else if (val === 2) {
    return '重度';
  }
  return val;
}
/**
   * 部位酸痛值格式化
   */
function sorenessFormatter(row, column) {
  var val = row[column.property];
  if (val == 0) {
    return '无';
  } else if (val == 1) {
    return '轻度';
  } else if (val == 2) {
    return '重度';
  }
  return val;
}

/**
   * 酸痛程度格式化
   */
function acheDegreeFormatter(row, column) {
  var val = row[column.property];
  if (val == 0) {
    return '无酸痛';
  } else if (val == 1) {
    return '一级酸痛';
  } else if (val == 2) {
    return '二级酸痛';
  } else if (val == 3) {
    return '三级酸痛';
  } else if (val == 4) {
    return '四级酸痛';
  } else if (val == 5) {
    return '五级酸痛';
  }
  return val;
}
/**
   * 脉率/血氧值格式化
   */
function bloodoxygenPulseRateFormatter(row, column) {
  var val = row[column.property];
  if (val === 0) {
    return '/';
  } else {
    return val;
  }
}
/**
   * 脉率/血氧值格式化
   */
function supportSecretKeyFormatter(row, column) {
  var val = row[column.property];
  if (val === 0) {
    return '不支持';
  } else if (val === 1) {
    return '支持';
  } else {
    return val;
  }
}
/**
   * 操作类别格式化
   */
function businessTypeFormatter(row, column) {
  var val = row[column.property];
  if (val === 0) {
    return '其它';
  } else if (val === 1) {
    return '新增';
  } else if (val === 2) {
    return '修改';
  } else if (val === 3) {
    return '删除';
  } else if (val === 4) {
    return '授权';
  } else if (val === 5) {
    return '导出';
  } else if (val === 6) {
    return '导入';
  } else if (val === 7) {
    return '强退';
  } else if (val === 8) {
    return '生成代码';
  } else if (val === 9) {
    return '清空';
  } else if (val === 10) {
    return '登录';
  } else if (val === 11) {
    return '登出';
  } else {
    return val;
  }
}


/**
   * 配置-品牌管理-是否独立用户体系
   */
function independentUserSysFormatter(row, column) {
  var val = row[column.property];
  if (val == 'Y') {
    return '是';
  } else if (val == 'N') {
    return '否';
  } else {
    return val;
  }
}

/**
   * 配置-产品功能配置-上架状态
   */
function shelfStatusFormatter(row, column) {
  var val = row[column.property];
  if (val == '0') {
    return '未上架';
  } else if (val == '1') {
    return '已上架';
  } else {
    return val;
  }
}

/**
   * 配置-今日推荐配置-商家状态
   */
function recommendStatusFormatter(row, column) {
  var val = row[column.property];
  if (val == 0) {
    return '已下架';
  } else if (val == 1) {
    return '已上架';
  } else {
    return val;
  }
}

/**
   * 配置-今日推荐-新用户推荐原因
   */
function recommendNewReasonFormatter(row, column) {
  var val = row[column.property];
  if (val == 1) {
    return '猜你喜欢';
  } else if (val == 2) {
    return '普通套餐';
  } else {
    return val;
  }
}

/**
   * OTA-硬件模块维护-模块类型
   */
function hardwareModuleTypeFormatter(row, column) {
  var val = row[column.property];
  if (val == 1) {
    return '中心板';
  } else if (val == 2) {
    return 'WiFi板';
  } else if (val == 3) {
    return '语音板';
  } else if (val == 4) {
    return '机芯板';
  } else if (val == 5) {
    return '小腿板';
  } else {
    return val;
  }
}

/**
   * OTA-升级管理-是否强制升级
   */
function otaIsForceFormatter(row, column) {
  var val = row[column.property];
  if (val == 0) {
    return '不强制';
  } else if (val == 1) {
    return '强制';
  } else {
    return val;
  }
}

/**
   * OTA-升级管理-升级范围
   */
function otaRangeformatter(row, column) {
  var val = row[column.property];
  if (process.env.VUE_APP_OG_ENV == 'americaDevelopment' || process.env.VUE_APP_OG_ENV == 'asiaProduction' || process.env.VUE_APP_OG_ENV == 'americaProduction') {
    //海外
    if (val == 1) {
      return '全域升级';
    } else if (val == 3) {
      return '精准升级';
    } else {
      return val;
    }
  } else {
    //国内||测试环境
    if (val == 1) {
      return '全国升级';
    } else if (val == 2) {
      return '区域升级';
    } else if (val == 3) {
      return '精准升级';
    } else {
      return val;
    }
  }
}

/**
   * OTA-升级管理-状态
   */
function otaAuditStatusFormatter(row, column) {
  var val = row[column.property];
  if (val == 0) {
    return '未审核';
  } else if (val == 1) {
    return '审核发布';
  } else {
    return val;
  }
}

/**
   * OTA-升级管理-升级情况的升级状态
   */
function otaSituationStatusFormatter(row, column) {
  var val = row[column.property];
  if (val == 0) {
    return '未启动';
  } else if (val == 1) {
    return '发送命令成功(升级中)';
  } else if (val == 2) {
    return '版本更新升级成功';
  } else if (val == 3) {
    return '发送命令失败或过期失败';
  } else if (val == 4) {
    return '开始升级';
  } else if (val == 6) {
    return '没有升级任务';
  } else {
    return val;
  }
}

/**
   * 信息-意见反馈-通知类型
   */
function msgFeedbackNoticeType(row, column) {
  var val = row[column.property];
  if (val == 1) {
    return '意见反馈';
  } else if (val == 2) {
    return '投诉建议';
  } else {
    return val;
  }
}

/**
   * 信息-意见反馈-通知邮箱
   */
function msgFeedbackEmails(row, column) {
  var val = row[column.property];
  if (val.length) {
    return val.join(';');
  } else {
    return '无';
  }
}

/**
   * 设备管理-设备信息维护-设备型号
   */
function deviceTypeFormatter(row, column) {
  if (row[column.property] && row['deviceTypeName']) {
    return row[column.property] + '/' + row['deviceTypeName'];
  } else {
    return '暂无';
  }
}

/**
   * App升级日志-升级状态
   */
function appUpgradeLogStatus(row, column) {
  var val = row[column.property];
  if (val == 0) {
    return '开始升级';
  } else if (val == 1) {
    return '升级成功';
  } else if (val == 2) {
    return '升级失败';
  } else {
    return val;
  }
}

/**
   * 静态资源管理-文件类型
   */
function staticManageFileTypeFormatter(row, column) {
  var val = row[column.property];
  if (val == 1) {
    return '设备H5';
  } else if (val == 2) {
    return '说明书';
  } else if (val == 3) {
    return '自定义';
  } else if (val == 4) {
    return '后台';
  } else {
    return val;
  }
}

/**
   * 静态资源管理-上传状态
   */
function staticManageUploadStatusFormatter(row, column) {
  var val = row[column.property];
  if (val == 1) {
    return '上传成功';
  } else if (val == 2) {
    return '上传失败';
  } else {
    return val;
  }
}